
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaSync } from 'react-icons/fa';
import Header from "../../Component/Header";
import { Container, Row, Col, Card, Form, Table, Pagination, Dropdown, Offcanvas, Button, Badge } from "react-bootstrap";
import Select from "react-select";
import { FiFilter } from "react-icons/fi";
import exportIcon from "../../assets/images/export-icon.svg";
import totalRequestIcon from "../../assets/images/total-request-icon.svg";
import activeJobsIcon from "../../assets/images/active-jobs-icon.svg";
import deployedJobIcon from "../../assets/images/deployed-jobs-icon.svg";
import reloadIcon from "../../assets/images/reload-icon.svg";
import expandIcon from "../../assets/images/expand-icon.svg";

import highPriorityIcon from "../../assets/images/high-priority-icon.svg";
import LowPriorityIcon from "../../assets/images/low-priority-icon.svg";
import inprogressStatusIcon from "../../assets/images/inprogress-status-icon.svg";
import deployedStatusIcon from "../../assets/images/deployed-status-icon.svg";
import additionStatusIcon from "../../assets/images/additional-asset-status-icon.svg";
import FullScreenLoader from "../../Component/Loader";

import {
    getStats,
    getFilterOptions,
    getJobs,
    exportJobsData
} from "../../Services/dashboard";

import "./style.css";

const Dashboard = () => {

    const navigate = useNavigate();
    const [showLoader, setShowLoader] = useState(false);
    const [showFiltersDrawer, setShowFiltersDrawer] = useState(false);

    const [regionOptions, setRegionOptions] = useState([]);
    const [customerOptions, setCustomerOptions] = useState([]);
    const [jobOptions, setJobOptions] = useState([]);
    const [portalJobOptions, setPortalJobOptions] = useState([]);

    const [salesManOptions, setSalesManOptions] = useState([]);
    const [statusOptions, setStatusOptions] = useState([]);
    const [jobNameOptions, setJobNameOptions] = useState([]);

    const [selectedRegion, setSelectedRegion] = useState('');
    const [selectedCustomer, setSelectedCustomer] = useState('');
    const [selectedJob, setSelectedJob] = useState('');
    const [selectedSalesMan, setSelectedSalesMan] = useState('');
    const [selectedStatus, setSelectedStatus] = useState('');
    const [selectedJobName, setSelectedJobName] = useState('');
    const [selectedPortalJobName, setSelectedPortalJobName] = useState('');
    const [statsData, setStatsData] = useState({});
    const [tableData, setTableData] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [loading, setLoading] = useState(false);
    const [exporting, setExporting] = useState(false);

    // Compute active filters count (non-empty values)
    const activeFiltersCount = [
        selectedRegion,
        selectedCustomer,
        selectedJob,
        selectedSalesMan,
        selectedStatus,
        selectedJobName
    ].filter(value => value !== '').length;

    useEffect(() => {
        fetchFilters();
        fetchStats();
    }, []);

    // Fetch table data whenever any filter or pagination changes
    useEffect(() => {
        fetchTableData();
    }, [pageNumber, pageSize, selectedRegion, selectedCustomer, selectedJob, selectedSalesMan, selectedStatus, selectedJobName, selectedPortalJobName]);

    let fetchStats = async () => {
        let res = await getStats(localStorage.access_token);
        if (res?.data && res?.data?.status_code == 200) {
            setStatsData(res?.data?.result?.result);
        }
    };

    const fetchFilters = async () => {
        setShowLoader(true)
        let res = await getFilterOptions(localStorage.access_token);
        setShowLoader(false)
        if (res?.data?.status_code === 200) {
            const result = res.data.result;
            setRegionOptions(mapToOptions(result?.selected_country));
            setCustomerOptions(mapToOptions(result?.customer));
            setJobOptions(mapToOptions(result?.job_type));
            setPortalJobOptions(mapToOptions(result?.Portal_jobs))
            setSalesManOptions(mapToOptions(result?.sales_name));
            setStatusOptions(mapToOptions(result?.status));
            setJobNameOptions(mapToOptions(result?.job_name));
        }
    };

    let fetchTableData = async () => {
        setLoading(true);
        try {
            let payload = {
                "country": selectedRegion,
                "page_number": pageNumber,
                "page_size": pageSize,
                "location": "",
                "customer": selectedCustomer,
                "job_type": selectedJob,
                "sales_name": selectedSalesMan,
                "status": selectedStatus,
                "job_name": selectedJobName,
                "Portal_JobName": selectedPortalJobName
            };
            let res = await getJobs(localStorage.access_token, payload);
            if (res?.data && res?.data?.status_code == 200) {
                setTableData(res.data?.result?.result?.data || []);
                setTotalRecords(res.data?.result?.result?.total_records || 0);
            }
        } catch (error) {
            console.error("Error fetching table data:", error);
        } finally {
            setLoading(false);
        }
    };

    let downloadJobsData = async () => {
        setExporting(true);
        try {
            let payload = {
                location: "",
                customer: selectedCustomer,
                job_type: selectedJob,
                sales_name: selectedSalesMan,
                country: selectedRegion,
                status: selectedStatus,
                job_name: selectedJobName
            };

            let res = await exportJobsData(localStorage.access_token, payload);

            if (res?.data) {
                let csvContent = '';

                if (typeof res.data === 'string') {
                    csvContent = res.data;
                } else if (res.data?.data && typeof res.data.data === 'string') {
                    csvContent = res.data.data;
                } else if (res.data instanceof Blob) {
                    const url = window.URL.createObjectURL(res.data);
                    const link = document.createElement('a');
                    link.href = url;
                    const contentDisposition = res.headers?.['content-disposition'];
                    let filename = 'jobs_export.csv';
                    if (contentDisposition) {
                        const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/i);
                        if (filenameMatch && filenameMatch.length > 1) {
                            filename = filenameMatch[1];
                        }
                    }
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                    setExporting(false);
                    return;
                }

                if (csvContent) {
                    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    const now = new Date();
                    const dateStr = `${now.getFullYear()}${(now.getMonth() + 1).toString().padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}`;
                    const filename = `jobs_export_${dateStr}.csv`;
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                } else {
                    throw new Error('No CSV data found in response');
                }
            } else {
                throw new Error('Empty response from server');
            }
        } catch (error) {
            console.error("Error exporting data:", error);
            alert("Failed to export data. Please try again.");
        } finally {
            setExporting(false);
        }
    };

    const mapToOptions = (arr = []) => [
        { value: '', label: 'All' },
        ...arr.map(item => ({
            value: item,
            label: item
        }))
    ];

    const getSelectedOption = (options, value) => {
        return options.find(option => option.value === value) || options.find(option => option.value === '');
    };

    const handleApplyFilters = () => {
        setPageNumber(1);  // Reset to first page, useEffect will trigger fetch
        setShowFiltersDrawer(false);
    };

    const handleClearAllFilters = () => {
        setSelectedRegion('');
        setSelectedCustomer('');
        setSelectedJob('');
        setSelectedSalesMan('');
        setSelectedStatus('');
        setSelectedJobName('');
        setSelectedPortalJobName('')
        setPageNumber(1);
        setShowFiltersDrawer(false);
        // No need to call fetchTableData – useEffect will pick up the cleared values
    };

    const handlePageSizeChange = (size) => {
        setPageSize(size);
        setPageNumber(1);
    };

    const handlePageChange = (page) => {
        setPageNumber(page);
    };

    const getStatusIcon = (status) => {
        switch (status?.toLowerCase()) {
            case 'inprogress':
                return inprogressStatusIcon;
            case 'deployed':
                return deployedStatusIcon;
            case 'additional asset':
                return additionStatusIcon;
            default:
                return inprogressStatusIcon;
        }
    };

    const getStatusClass = (status) => {
        switch (status?.toLowerCase()) {
            case 'inprogress':
                return 'btn-inprogress-txt';
            case 'deployed':
                return 'btn-deployed-txt';
            case 'additional asset':
                return 'btn-addt-asst-txt';
            default:
                return 'btn-inprogress-txt';
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric'
        });
    };

    const totalPages = Math.ceil(totalRecords / pageSize);

    const getPaginationItems = () => {
        const items = [];
        const maxVisiblePages = 7;

        if (totalPages <= maxVisiblePages) {
            for (let i = 1; i <= totalPages; i++) {
                items.push(i);
            }
        } else {
            items.push(1);
            let startPage = Math.max(2, pageNumber - 2);
            let endPage = Math.min(totalPages - 1, pageNumber + 2);
            if (pageNumber <= 3) {
                endPage = Math.min(totalPages - 1, 5);
            }
            if (pageNumber >= totalPages - 2) {
                startPage = Math.max(2, totalPages - 4);
            }
            if (startPage > 2) {
                items.push('...');
            }
            for (let i = startPage; i <= endPage; i++) {
                items.push(i);
            }
            if (endPage < totalPages - 1) {
                items.push('...');
            }
            if (totalPages > 1) {
                items.push(totalPages);
            }
        }
        return items;
    };

    console.log("tableData", tableData)

    const renderTableRows = () => {
        if (loading) {
            return (
                <tr>
                    <td colSpan="11" className="text-center py-4">
                        Loading...
                    </td>
                </tr>
            );
        }

        if (tableData.length === 0) {
            return (
                <tr>
                    <td colSpan="11" className="text-center py-4">
                        No data available
                    </td>
                </tr>
            );
        }

        return tableData.map((job, index) => (
            <tr key={job.job_id || index}>
                <td><span className="parg-txtwap">{job.region}</span></td>
                <td>
                    <div className="location-wp-bx text-nowrap">
                        <span className="dot-circle-loct dot-color-green"></span>
                        {job.location || 'N/A'}
                    </div>
                </td>
                <td><span className="parg-txtwap">{job.customer || 'N/A'}</span></td>
                <td><span className="parg-txtwap">{job.jobtype}</span></td>
                <td><span className="parg-txtwap">{job.jobname}</span></td>
                <td><span className="parg-txtwap">{job.PortalJobname}</span></td>
                <td><span className="parg-txtwap text-nowrap">{formatDate(job.due_on_site)}</span></td>
                <td>
                    <span className={`btn-status-prgs ${getStatusClass(job.status)} text-nowrap`}>
                        <img src={getStatusIcon(job.status)} className="me-1" alt="" />
                        {job.status}
                    </span>
                </td>
                <td className="text-center">
                    <span className="numb-txt-requird">{job.personnel_required || '0'}</span>
                </td>
                <td>
                    <div className="sales-man-pic">
                        <span className="parg-txtwap ps-2 text-nowrap">{job.salesman}</span>
                    </div>
                </td>
                {/* <td className="text-center">
                    <button
                        type="button"
                        className="btn btn-load-out p-0"
                        onClick={() =>
                            window.open(
                                `/home/${job.job_id}/${job.region.includes('can') ? 'CANADA' : 'USA'}`,
                                '_blank'
                            )
                        }
                    >
                        <img src={expandIcon} alt="icon" />
                    </button>
                </td> */}
                <td className="text-center">
                    {/* ---------- Open button ---------- */}
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id="tooltip-open">Open job details</Tooltip>}
                    >
                        <button
                            type="button"
                            className="btn btn-load-out p-0 me-1"
                            onClick={() =>
                                window.open(
                                    `/home/${job.job_id}/${job.region.includes('can') ? 'CANADA' : 'USA'}`,
                                    '_blank'
                                )
                            }
                        >
                            <img src={expandIcon} alt="open" />
                        </button>
                    </OverlayTrigger>

                    {/* ---------- Resupply button ---------- */}
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id="tooltip-resupply">Resupply</Tooltip>}
                    >

                        <button
                            disabled={job?.status !== 'Deployed'}
                            onClick={() => {
                                const country = job.region?.includes('can') ? 'CANADA' : 'USA';
                                const url =
                                    !job.Request_ID || job.Request_ID === 'null'
                                        ? `/home/${job.job_id}/${country}?requestType=Resupply&jobDetailsId=${job.job_Details_ID}`
                                        : `/home/${job?.job_Details_ID}/${job.Request_ID}/${job.job_id}/${country}`;

                                window.open(url, '_blank');
                            }}
                            style={{
                                marginLeft: '5px',
                                border: job?.status !== 'Deployed' ? 'none' : '',
                                outline: job?.status !== 'Deployed' ? 'none' : '',
                                boxShadow: job?.status !== 'Deployed' ? 'none' : '',
                            }}
                            type="button"
                            className="btn btn-load-out p-0"
                        >
                            <FaSync size={18} style={{ color: '#82a2cc' }} />
                        </button>
                    </OverlayTrigger>
                </td>
            </tr>
        ));
    };

    return (
        <>
            <div className="wrapper">
                <Header />
                {showLoader ? <FullScreenLoader /> : null}
                <div className="full-dashboard-body">
                    {/* Top Header Section */}
                    <div className="top-head-jobcontent">
                        <Container fluid>
                            <Row>
                                <Col xs={12}>
                                    <div className="d-sm-flex flex-sm-wrap align-items-sm-center">
                                        <div className="heading-job-upcoming mb-3 mb-sm-0">
                                            <h2 className="title-h2 mb-0">Load Out Operations Dashboard</h2>
                                            <p className="small-parg-wt">Monitor and manage job readiness and asset allocation</p>
                                        </div>
                                        <div className="button-expt">
                                            <button
                                                type="button"
                                                className="btn btn-export-web"
                                                onClick={downloadJobsData}
                                                disabled={exporting}
                                            >
                                                {exporting ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                                        Exporting...
                                                    </>
                                                ) : (
                                                    <>
                                                        <img src={exportIcon} className="me-1" alt="" />
                                                        Export
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>

                    {/* Stats Cards Section */}
                    <div className="job-section-area">
                        <Container fluid>
                            <Row>
                                <Col xs={12} md={6} lg={6} xl={3}>
                                    <Card className="job-card-view">
                                        <div className="job-icon-flx">
                                            <img src={totalRequestIcon} alt="" />
                                        </div>
                                        <div className="job-info-flx">
                                            <h5 className="total-txt-wt">Total upcoming jobs</h5>
                                            <h3 className="total-numb-wp">{statsData?.total_requests}</h3>
                                        </div>
                                    </Card>
                                </Col>
                                <Col xs={12} md={6} lg={6} xl={3}>
                                    <Card className="job-card-view">
                                        <div className="job-icon-flx">
                                            <img src={activeJobsIcon} alt="" />
                                        </div>
                                        <div className="job-info-flx">
                                            <h5 className="total-txt-wt"> Loadout Requests - Inprogress</h5>
                                            <h3 className="total-numb-wp">{statsData?.active_jobs}</h3>
                                        </div>
                                    </Card>
                                </Col>
                                <Col xs={12} md={6} lg={6} xl={3}>
                                    <Card className="job-card-view">
                                        <div className="job-icon-flx">
                                            <img src={deployedJobIcon} alt="" />
                                        </div>
                                        <div className="job-info-flx">
                                            <h5 className="total-txt-wt">Loadout Requests - Deployed Active</h5>
                                            <h3 className="total-numb-wp">{statsData?.deployed_jobs}</h3>
                                        </div>
                                    </Card>
                                </Col>
                                <Col xs={12} md={6} lg={6} xl={3}>
                                    <Card className="job-card-view">
                                        <div className="flex-fill">
                                            <h5 className="total-txt-wt">upcoming Jobs by Region</h5>
                                            <div className="row-dual-flx">
                                                <div className="col-wgt-two">
                                                    <div className="boxstate-gyt bg-color-st-1">
                                                        <span className="state-txt-mtw"><span className="circle-st blue-clr"></span>United States</span>
                                                        <h3 className="total-numb-wp">{statsData?.regional_breakup?.usa}</h3>
                                                    </div>
                                                </div>
                                                <div className="col-wgt-two">
                                                    <div className="boxstate-gyt bg-color-st-2">
                                                        <span className="state-txt-mtw"><span className="circle-st green-clr"></span>Canada</span>
                                                        <h3 className="total-numb-wp">{statsData?.regional_breakup?.canada}</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Card>
                                </Col>
                            </Row>
                        </Container>
                    </div>

                    {/* Filter Button Section - Opens Drawer with count badge */}
                    <div className="global-filters">
                        <Container fluid>
                            <Row>
                                <Col xs={12} className="text-end">
                                    <button
                                        type="button"
                                        className="btn btn-primary d-inline-flex align-items-center global-filtr-btn position-relative"
                                        style={{ borderRadius: "8px", padding: "8px 20px" }}
                                        onClick={() => setShowFiltersDrawer(true)}
                                    >
                                        <FiFilter className="me-2" size={18} />
                                        Filters
                                        {activeFiltersCount > 0 && (
                                            <Badge bg="light" text="dark" className="ms-2 rounded-pill">
                                                {activeFiltersCount}
                                            </Badge>
                                        )}
                                    </button>
                                </Col>
                            </Row>
                        </Container>
                    </div>

                    {/* Table Section */}
                    <div className="full-tablejob-contain pb-4">
                        <Container fluid>
                            <Row>
                                <Col xs={12}>
                                    <div className="tablecontent-job-lstwp">
                                        <Table responsive className="chart-table-jobweb mb-0">
                                            <thead className="job-theadtable">
                                                <tr>
                                                    <th>REGION</th>
                                                    <th>Location</th>
                                                    <th>Customer</th>
                                                    <th className="text-nowrap">Job Type</th>
                                                    <th className="text-nowrap">Job Name</th>
                                                    <th className="text-nowrap">Portal Job Name</th>
                                                    <th className="text-nowrap">Due On site</th>
                                                    <th>Status</th>
                                                    <th className="text-center">Personnel</th>
                                                    <th>Salesman</th>
                                                    <th className="text-center">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody className="job-tbodytable">
                                                {renderTableRows()}
                                            </tbody>
                                        </Table>

                                        {/* Pagination */}
                                        <div className="d-md-flex align-md-items-center justify-content-md-between p-3 bg-white">
                                            <div className="dropdown-page-numb d-flex align-items-center mb-3 mb-md-0 justify-content-center">
                                                <div className="d-inline-block txtlabel-bt pe-2">
                                                    <span className="txt-label-wts">Per Page</span>
                                                </div>
                                                <Dropdown className="dropdown-page-count">
                                                    <Dropdown.Toggle variant="success" className="btn-select-dropcount" id="dropdown-basic">
                                                        {pageSize}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu className="dropdown-menu-count">
                                                        <Dropdown.Item onClick={() => handlePageSizeChange(10)}>10</Dropdown.Item>
                                                        <Dropdown.Item onClick={() => handlePageSizeChange(20)}>20</Dropdown.Item>
                                                        <Dropdown.Item onClick={() => handlePageSizeChange(50)}>50</Dropdown.Item>
                                                        <Dropdown.Item onClick={() => handlePageSizeChange(100)}>100</Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>
                                            <div className="pagination-table-web">
                                                <Pagination className="mb-0 justify-content-center">
                                                    <Pagination.First onClick={() => handlePageChange(1)} disabled={pageNumber === 1} />
                                                    <Pagination.Prev onClick={() => handlePageChange(Math.max(1, pageNumber - 1))} disabled={pageNumber === 1} />
                                                    {getPaginationItems().map((item, index) => {
                                                        if (item === '...') {
                                                            return <Pagination.Ellipsis key={`ellipsis-${index}`} disabled />;
                                                        }
                                                        return (
                                                            <Pagination.Item key={item} active={pageNumber === item} onClick={() => handlePageChange(item)}>
                                                                {item}
                                                            </Pagination.Item>
                                                        );
                                                    })}
                                                    <Pagination.Next onClick={() => handlePageChange(Math.min(totalPages, pageNumber + 1))} disabled={pageNumber === totalPages} />
                                                    <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={pageNumber === totalPages} />
                                                </Pagination>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </div>
            </div>

            {/* Filters Drawer (Offcanvas) - contains ALL filters including Job Name */}
            <Offcanvas show={showFiltersDrawer} onHide={() => setShowFiltersDrawer(false)} placement="end" scroll={true} backdrop={true}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Filter Jobs</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Region</Form.Label>
                            <Select
                                classNamePrefix="react-select-filter"
                                options={regionOptions}
                                placeholder="Select"
                                isSearchable={true}
                                value={getSelectedOption(regionOptions, selectedRegion)}
                                onChange={(option) => setSelectedRegion(option.value)}
                                // menuPortalTarget={document.body}
                                menuShouldScrollIntoView={false}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Customer</Form.Label>
                            <Select
                                classNamePrefix="react-select-filter"
                                options={customerOptions}
                                placeholder="Select"
                                isSearchable={true}
                                value={getSelectedOption(customerOptions, selectedCustomer)}
                                onChange={(option) => setSelectedCustomer(option.value)}
                                // menuPortalTarget={document.body}
                                menuShouldScrollIntoView={false}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Job Name</Form.Label>
                            <Select
                                classNamePrefix="react-select-filter"
                                options={jobNameOptions}
                                placeholder="Select"
                                isSearchable={true}
                                value={getSelectedOption(jobNameOptions, selectedJobName)}
                                onChange={(option) => setSelectedJobName(option.value)}
                                // menuPortalTarget={document.body}
                                menuShouldScrollIntoView={false}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Portal Job Name</Form.Label>
                            <Select
                                classNamePrefix="react-select-filter"
                                options={portalJobOptions}
                                placeholder="Select"
                                isSearchable={true}
                                value={getSelectedOption(portalJobOptions, selectedPortalJobName)}
                                onChange={(option) => setSelectedPortalJobName(option.value)}
                                // menuPortalTarget={document.body}
                                menuShouldScrollIntoView={false}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Job Type</Form.Label>
                            <Select
                                classNamePrefix="react-select-filter"
                                options={jobOptions}
                                placeholder="Select"
                                isSearchable={true}
                                value={getSelectedOption(jobOptions, selectedJob)}
                                onChange={(option) => setSelectedJob(option.value)}
                                // menuPortalTarget={document.body}
                                menuShouldScrollIntoView={false}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Salesman</Form.Label>
                            <Select
                                classNamePrefix="react-select-filter"
                                options={salesManOptions}
                                placeholder="Select"
                                isSearchable={true}
                                value={getSelectedOption(salesManOptions, selectedSalesMan)}
                                onChange={(option) => setSelectedSalesMan(option.value)}
                                // menuPortalTarget={document.body}
                                menuShouldScrollIntoView={false}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Status</Form.Label>
                            <Select
                                classNamePrefix="react-select-filter"
                                options={statusOptions}
                                placeholder="Select"
                                isSearchable={true}
                                value={getSelectedOption(statusOptions, selectedStatus)}
                                onChange={(option) => setSelectedStatus(option.value)}
                                // menuPortalTarget={document.body}
                                menuShouldScrollIntoView={false}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                        </Form.Group>

                        <div className="d-flex gap-2 mt-4">
                            {/* Apply Filters button is commented out as in original code */}
                            <Button variant="primary" onClick={handleApplyFilters} className="flex-grow-1 global-filtr-btn">
                                Apply
                            </Button>
                            <Button
                                variant="outline-secondary"
                                onClick={handleClearAllFilters}
                                className="flex-grow-1 global-filtr-btn"
                            // disabled={activeFiltersCount === 0}
                            >
                                Clear All
                            </Button>
                        </div>
                    </Form>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default Dashboard;